import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import StreamingLayout from '@t7x000/apex-web/lib/layouts/StreamingLayouts/StreamingLayout';
import StreamingGridContainer from '@t7x000/apex-web/lib/components/Streaming/StreamingGridContainer';
import RecentActivityWithFilterContainer from '@t7x000/apex-web/lib/components/RecentActivityWithFilter';
import BalancesListLayout from '@t7x000/apex-web/lib/layouts/BalancesListLayout/BalancesListLayout';
import {
  accountsSelector,
  selectedAccountIdSelector,
} from '@t7x000/apex-web/lib/redux/margin/selectors/marginSelectors';
import { selectAccount } from '@t7x000/apex-web/lib/redux/actions/userActions';
import PageFooterLayout from '../layouts/PageFooterLayout/PageFooterLayout';
import './StreamingPage.css';

const StreamingPage = () => {
  const dispatch = useDispatch();
  const accounts = useSelector(accountsSelector);
  const selectedAccountId = useSelector(selectedAccountIdSelector);

  useEffect(() => {
    const selectedAccount = accounts.find((account) => account.AccountId === selectedAccountId);
    const isSelectedAccountSpot = selectedAccount && selectedAccount.AccountType === 'Asset';

    if (!isSelectedAccountSpot) {
      const spotAccount = accounts.find((account) => account.AccountType === 'Asset');
      if (spotAccount) {
        dispatch(selectAccount(spotAccount.AccountId, spotAccount.OMSID));
      }
    }
  }, [accounts, selectedAccountId, dispatch]);

  return (
    <StreamingLayout
      component1={<StreamingGridContainer />}
      component2={<BalancesListLayout />}
      component3={<RecentActivityWithFilterContainer filterForSelected={false} pageSize={10} minRow={10} />}
      footer={<PageFooterLayout />}
    />
  );
};

export default StreamingPage;
